import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import {
    validateAKVLinkedserviceReference,
    validateNullLinkedserviceReference
} from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { AzureStorageLinkedService } from './azure-storage.linkedservice';
import { AzureBlobFSLinkedService, IValidationContext, IViolation } from 'shell-models-lib';
import { adfModelTypeMap } from '../../registries/consts/adf-model-type-map-const';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';
import { ExposureControlService } from 'app/services/exposure-control/base-exposure-control.service';
import { GuardFeatures } from 'app/services/exposure-control/ec.typings';

import { driverVersions } from 'app/registries/consts/tabular-consts';
import { LinkedServiceUtils } from './linked-service.utils';
export const hiveAuthTypes = {
    Anonymous: 'Anonymous',
    Username: 'Username',
    UsernameAndPassword: 'UsernameAndPassword',
    WindowsAzureHDInsightService: 'WindowsAzureHDInsightService'
};

@Metamodel.model({
    name: adfModelTypeMap.hive.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Hive_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Hive_DisplayText)
    ]
})
export class HiveLinkedService extends LinkedService {
    public static readonly MODEL: IModel;
    @Metamodel.attribute({
        display: stringResources.DriverVersion
    })
    public version?: string = driverVersions.v2;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host
    })
    public host?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port
    })
    public port?: number;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServerType
    })
    public serverType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ThriftTransportProtocol
    })
    public thriftTransportProtocol?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServiceDiscoveryMode
    })
    public serviceDiscoveryMode?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_ZooKeeperNameSpace
    })
    public zooKeeperNameSpace?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseNativeQuery
    })
    public useNativeQuery?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public username?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_HttpPath
    })
    public httpPath?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_EnableSSL
    })
    public enableSsl?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_TrustedCertPath
    })
    public trustedCertPath?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseSystemTrustStore
    })
    public useSystemTrustStore?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_AllowHostNameCNMismatch
    })
    public allowHostNameCNMismatch?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_AllowSelfSignedServerCert
    })
    public allowSelfSignedServerCert?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_EnableServerCertificateValidation
    })
    public enableServerCertificateValidation?: boolean = true;

    @Metamodel.attribute({
        reference: true,
        type: AzureStorageLinkedService.MODEL,
        constraint: {
            validator: HiveLinkedService.validateAzureStorageLinkedService
        }
    })
    public azureStorageLinkedService?: AzureStorageLinkedService | AzureBlobFSLinkedService;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    private static async validateAzureStorageLinkedService(
        linkedservice: LinkedService,
        referencedResource: AzureStorageLinkedService | AzureBlobFSLinkedService,
        violation?: IViolation,
        context?: IValidationContext
    ): Promise<IViolation[] | undefined> {
        const isHiveStorageAccountEnabled = (
            await getServiceInstance<ExposureControlService>(context.contextData, 'ExposureControlService')
        ).getCachedFeatureValue<boolean>(GuardFeatures.ADFDataflowEnableHive);
        if (isHiveStorageAccountEnabled) {
            return validateNullLinkedserviceReference(linkedservice, referencedResource, violation, context);
        }
        return undefined;
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): HiveLinkedService {
        return LinkedServiceUtils.commonV1ToV2(context, this) as HiveLinkedService;
    }
}
